import Vue from 'vue'
import store from '../stores/store'

Vue.directive('can', function (el, binding) {
    el.style.display = !store.getters.can(binding.arg, binding.value) ? 'none' : ''
})

Vue.directive('btn-loading', function (el, binding) {
    if (binding.value !== binding.oldValue) {
        if (binding.value) {
            el.disabled = true
            el.innerHTML += '<i class="fa v-btn-loading fa-circle-notch fa-spin" />'
        } else {
            el.disabled = false
            el.querySelectorAll('.v-btn-loading').forEach(fa => fa.remove())
        }
    }
})

Vue.directive('click-outside', {
    componentUpdated: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event)
            }
        }

        document.addEventListener('click', el.clickOutsideEvent)
    },

    unbind: function (el) {
        document.removeEventListener('click', el.clickOutsideEvent)
    },
})
